import React, { Component } from 'react'

import Datagrid from '@/ui/DataTable/Datagrid'
import ListTable from '@/ui/DataTable/List'

// Already themed when importing from collection
import { AvatarField, ButtonField, CombinedField, TextField, BooleanField } from '@/ui/Data'
import { EditButton, Button, ButtonGroup } from '@/ui/Button'
import { Container, Row, Cell } from '@/ui/Element'
import { Tooltip } from '@/ui/Tooltip'

import { crudDelete } from '@/state/actions/data'
import { showModal, hideModal } from '@/state/actions/modal'
import { routeContactsEdit } from '@/state/actions/routes'

import UserOff from '@/icons/UserOff'
import EditIcon from '@/icons/Edit'

const Empty = () => <div style={{ width: '50px', height: '2.5em', display: 'inline-block' }} />

class Contacts extends Component {
  close = () => {
    this.props.dispatch(hideModal())
  }

  delete = record => {
    this.props.dispatch(
      crudDelete('contacts', record.id, false, { message: `${record.full_name} deleted.` }),
    )
    this.props.dispatch(hideModal())
  }

  edit = record => {
    this.props.dispatch(routeContactsEdit(record.id))
  }

  remove = record => {
    this.props.dispatch(
      showModal({
        title: 'Permanently delete $full_name?',
        record: record,
        content:
          `This will permanently delete $full_name from the contact list and ` +
          `it will no logner be accessible to anyone. All related items will ` +
          `remain. This action is irreversible.`,
        buttons: [
          <Button classes="inverted" key="cancel" onClick={this.close}>
            Cancel
          </Button>,
          <Button classes="danger" key="delete" onClick={() => this.delete(record)}>
            Delete
          </Button>,
        ],
      }),
    )
  }

  render() {
    const { theme, ...props } = this.props

    return (
      <Container>
        <Row spacing="double">
          <Cell>
            <ListTable {...props} resource="contacts" title={false}>
              <Datagrid>
                <CombinedField label="Contacts" cellName="contact" className={theme['contact-col']}>
                  <AvatarField source="picture" fallback="full_name" letter />
                  <CombinedField
                    className={`${theme['flex-vertical']} ${theme['flex-grow']} ${theme[
                      'text-left'
                    ]}`}
                  >
                    <EditButton source="full_name" title={false} click={this.edit} theme={theme} />
                    <TextField source="position" />
                  </CombinedField>
                </CombinedField>
                <ButtonGroup width="10rem" label="Manage">
                  <BooleanField
                    source="disabled"
                    compare={rec => rec.disabled && rec.disabled === 1}
                    whenTrue={
                      <div
                        className={`${theme['flex-middle']} ${theme['flex-center']} ${theme[
                          'button-clean'
                        ]} ${theme['button']}`}
                      >
                        <Tooltip content="Inactive">
                          <UserOff width="2.5em" height="2.5em" />
                        </Tooltip>
                      </div>
                    }
                    whenFalse={<Empty />}
                  />
                  <ButtonField
                    tag="div"
                    sortable={false}
                    click={this.edit}
                    classes={['flex-center', 'flex-middle']}
                  >
                    <Tooltip content="Edit contact">
                      <EditIcon size="2.5em" />
                    </Tooltip>
                  </ButtonField>
                </ButtonGroup>
              </Datagrid>
            </ListTable>
          </Cell>
        </Row>
      </Container>
    )
  }
}
export default Contacts



// WEBPACK FOOTER //
// ./view/Contacts/Contacts.js